import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

import { TemplateActualisationDto } from './sharepoint.model';

@Injectable({
  providedIn: 'root',
})
export class SharepointService {
  constructor(private http: HttpClient) {}

  public extractSharepointCustomerSpaceTemplate(): Observable<string> {
    return this.http.post<string>(`${environment.apiUrl}/sharepoint-templates/extract-customer-space-template`, null);
  }

  public extractSharepointProjectTemplate(): Observable<string> {
    return this.http.post<string>(`${environment.apiUrl}/sharepoint-templates/extract-project-template`, null);
  }

  public getLatestActualisedTemplates(): Observable<TemplateActualisationDto> {
    return this.http.get<TemplateActualisationDto>(`${environment.apiUrl}/sharepoint-templates/latest-actualisation`);
  }
}
